import { buildStaffMenu } from "./staffMenu"
// Also available for CSO-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * CSO role menu — cloned from the shared staff (LXO-derived) base.
 *
 * Currently mirrors the staff base exactly. To add CSO-specific
 * overrides without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildCsoMenu = () => buildStaffMenu()
